import { DataTestId, TextKey } from '@mews-commander/enums';
import { LocalizedSmallParagraph } from '@mews-commander/ui';
import { LocalizedText, lt, showSuccessAlert } from '@mews/framework';
import { Button, Dialog, IconName, Stack } from '@optimus-web/core';
import { copyToClipboard } from '@mews-commander/utils';
import { CodeElement } from './CodeElement';

export interface Configure2FADeviceConfigManualProps {
    manualCode: string;
    active: boolean;
    onClose: () => void;
}

export function Configure2FADeviceConfigManual({ manualCode, onClose, active }: Configure2FADeviceConfigManualProps) {
    const copyManualCodes = () => {
        copyToClipboard(manualCode);
        showSuccessAlert({ description: lt('CopyToClipboard') });
        onClose();
    };

    return (
        <Dialog
            active={active}
            size="small"
            title={<LocalizedText textKey={TextKey.CannotScanQRCode} />}
            onClose={onClose}
            footer={{
                primary: (
                    <Button icon={IconName.Copy} variant="secondary" onClick={copyManualCodes} type="submit">
                        <LocalizedText textKey={TextKey.Copy} />
                    </Button>
                ),
                secondary: (
                    <Button onClick={onClose} type="submit">
                        <LocalizedText textKey={TextKey.GoBack} />
                    </Button>
                ),
            }}
        >
            <Stack spacing="100" vertical>
                <LocalizedSmallParagraph textKey={TextKey.UseManualKey} />
                <CodeElement data-test-id={DataTestId.MfaCode}>{manualCode}</CodeElement>
            </Stack>
        </Dialog>
    );
}
